import Logger from '../../utils/Logger';
import { CONSENT } from '../reducer';
import { BIOBANK_STATUS } from '../../definitions/BioBankConstants';
//import BioBankConsent from '../../dto/BioBankConsent'
import {
  BIOBANK_REFUSAL_SUCCESSFUL_TOAST,
  BIOBANK_CONSENT_SUCCESSFUL_TOAST,
} from '../../definitions/ToastConstants';
import { doPushToast } from '../toasts/actions';
import { updateUserInfo } from '../user/profile/actions';

let { id: module_id } = module;
const logger = new Logger(module_id);

const createActionName = require('../util').createActionName('biobank');

export const GET_CONSENT_STATUS = createActionName('GET_CONSENT_STATUS');
export const UPDATE_CONSENT = createActionName('UPDATE_CONSENT');
export const GET_DOCUMENT_CONTENT = createActionName('GET_DOCUMENT_CONTENT');
export const RECEIVE_DOCUMENT_CONTENT = createActionName(
  'RECEIVE_DOCUMENT_CONTENT'
);
export const RESET_DOCUMENT_CONTENT = createActionName(
  'RESET_DOCUMENT_CONTENT'
);
export const GET_DOCUMENT_CONTENT_FAILED = createActionName(
  'GET_DOCUMENT_CONTENT_FAILED'
);
export const UPDATE_CONSENT_FAILED = createActionName('UPDATE_CONSENT_FAILED');
export const GET_CONSENT_STATUS_FAILED = createActionName(
  'GET_CONSENT_STATUS_FAILED'
);

export const GetConsentStatus = (data) => ({
  type: GET_CONSENT_STATUS,
  payload: { data },
});

export const UpdateConsent = (data) => ({
  type: UPDATE_CONSENT,
  payload: { data },
});

export const GetDocumentContent = (context) => ({
  context,
  type: GET_DOCUMENT_CONTENT,
});

export const ReceiveDocumentContent = (context, data) => ({
  context,
  type: RECEIVE_DOCUMENT_CONTENT,
  payload: { data },
});

export const ResetDocumentContent = (context) => ({
  context,
  type: RESET_DOCUMENT_CONTENT,
});

export const DocumentContentFail = (context, error) => ({
  context,
  type: GET_DOCUMENT_CONTENT_FAILED,
  payload: { error },
});

export const GetConsentStatusFail = (error) => ({
  type: GET_CONSENT_STATUS_FAILED,
  payload: { error },
});

export const UpdateConsentFail = (error) => ({
  type: UPDATE_CONSENT_FAILED,
  payload: { error },
});

const createConsentStatus = (data) => {
  let status = BIOBANK_STATUS.NONE;
  let validFrom = null;
  let incidental = null;
  let recontact = null;
  let version = null;
  let latestVersion = null;
  let versionApproved = null;
  if (data.documentType === 'CONSENT') {
    status = BIOBANK_STATUS.CONSENT;
    validFrom = data.validFrom;
    incidental = data.incidental;
    recontact = data.recontact;
    version = data.version;
    latestVersion = data.latestVersion;
    versionApproved = data.versionApproved;
  } else if (data.documentType === 'REFUSAL') {
    status = BIOBANK_STATUS.REFUSAL;
    validFrom = data.validFrom;
    version = data.version;
    latestVersion = data.latestVersion;
    versionApproved = data.versionApproved;
  }

  return {
    status,
    validFrom,
    incidental,
    recontact,
    version,
    latestVersion,
    versionApproved,
  };
};

export const doGetConsentStatus = () => (dispatch, getState, services) => {
  return new Promise((resolve, reject) => {
    services.api
      .getConsentStatus()
      .then((data) => {
        let consentStatus = createConsentStatus(data);

        return resolve(dispatch(GetConsentStatus(consentStatus)));
      })
      .catch((err) => {
        console.error(err);
        return reject(dispatch(GetConsentStatusFail(err)));
      });
  });
};

export const doUpdateConsent = (data) => (dispatch, getState, services) => {
  logger.debug({ data });
  return new Promise((resolve, reject) => {
    services.api
      .consentUpdate(data)
      .then((data) => {
        console.log('consentUpdate: ', data);
        if (data.documentType === 'REFUSAL') {
          dispatch(doPushToast(BIOBANK_REFUSAL_SUCCESSFUL_TOAST()));
        }
        if (data.documentType === 'CONSENT') {
          dispatch(doPushToast(BIOBANK_CONSENT_SUCCESSFUL_TOAST()));
        }
        let consentStatus = createConsentStatus(data);
        return resolve(dispatch(UpdateConsent(consentStatus)));
      })
      .catch((error) => {
        console.error(error);
        return reject(dispatch(UpdateConsentFail(error)));
      });
  });
};

/**
 * Set flag for whether biobank notificaitons should be shown. After successful
 * updating of the flag, fetch refreshed user info.
 *
 * @param data
 * @returns {Function}
 */
export const updateBioBankAgreement =
  (data) => (dispatch, getState, services) => {
    services.api.updateBioBankAgreement({ payload: data }).then(() => {
      dispatch(updateUserInfo());
    });
  };

export const resetDocumentContent = (context) => (dispatch) => {
  dispatch(ResetDocumentContent(context));
};

export const doGetDocumentContent =
  (context, documentType, documentVersion) =>
  (dispatch, getState, services) => {
    return new Promise((resolve, reject) => {
      dispatch(GetDocumentContent(context));
      services.api
        .documentContent({ documentType, documentVersion })
        .then((data) => {
          return resolve(dispatch(ReceiveDocumentContent(context, data)));
        })
        .catch((err) => {
          console.error(err);
          return reject(dispatch(DocumentContentFail(context, err)));
        });
    });
  };
